import React, { useState } from 'react'
import { Link } from 'gatsby'
import APIRefBlockDefSwagger from './APIRefBlockDefSwagger'
import CollapseButton from './CollapseButton'
import styles from './swagger-api.module.css'
import classNames from 'classnames'
import { orderBy } from 'lodash'
import { isDeprecated, hasDeprecatedFields } from '../../../lib/api-utils'
import HideDeprecatedCheckbox from './HideDeprecatedCheckbox'

export default function APIRecurSwagger({ definition, togglable = true }) {
  const [isOpen, setIsOpen] = useState(true)
  const [checked, setChecked] = useState(false)
  let result = null

  const handleClick = () => setChecked(!checked)

  if (definition && definition.allOf) {
    result = (
      <>
        {definition.allOf.map((eachAllOf, index) => {
          return (
            <APIRecurSwagger
              definition={eachAllOf}
              key={index}
              togglable={false}
            />
          )
        })}
      </>
    )
  } else if (definition && definition.items) {
    /**
     * Case where object is of type array TODO: check object=items
     */
    let itemsResult = definition.items.map((eachItem, index) => {
      return (
        <li className="dax-def-item" key={index}>
          <APIRefBlockDefSwagger block="block" parameter={eachItem} />
        </li>
      )
    })
    result = (
      <ul data-cy={`${definition.name}-list`} className="dax-def-list">
        {itemsResult}
      </ul>
    )
  } else if (definition && definition.properties) {
    const sortedRequiredProperties = orderBy(definition.properties, [
      'required',
      'name',
    ])
    /**
     *  Case where object is of type object
     */
    let propertiesResult = sortedRequiredProperties.map(
      (eachProperty, index) => {
        if (checked && isDeprecated(eachProperty)) {
          return null
        }
        return (
          <li className="dax-def-item" key={index}>
            <APIRefBlockDefSwagger block="block" parameter={eachProperty} />
          </li>
        )
      },
    )
    result = (
      <ul data-cy={`${definition.name}-list`} className="dax-def-list">
        {propertiesResult}
      </ul>
    )
  } else {
    /**
     * This is the case we have a definition that is not of type object or array
     *  typically of type String
     */
    result = (
      <ul className="dax-def-list" data-cy={`${definition.name}-list`}>
        <li className="dax-def-item">
          <APIRefBlockDefSwagger block="block" parameter={definition} />
        </li>
      </ul>
    )
  }

  return (
    <>
      {togglable && (
        <header
          className={classNames(
            'dax-topic-reference',
            'dx-flex',
            styles.attributesHeading,
          )}
        >
          <h4 className="dx-anchor">
            <Link
              className="dx-anchor__icon"
              to={`#definition-${definition.href}`}
              aria-hidden="true"
            />
            {definition.name}
          </h4>
          <CollapseButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} />
        </header>
      )}
      {isOpen && (
        <>
          {hasDeprecatedFields(definition.properties) && (
            <HideDeprecatedCheckbox onClick={handleClick} checked={checked} />
          )}
          {result}
        </>
      )}
    </>
  )
}
